/**
 * Payment method feature flags
 * Controlled via .env:
 *   VITE_FEATURE_PAYMENT_RESERVEPAY=true|false
 *   VITE_FEATURE_PAYMENT_BANK_TRANSFER=true|false
 *   VITE_FEATURE_PAYMENT_CARD=true|false         (ReservePay CARD)
 *
 * Default: PROMPTPAY + bankTransfer enabled, CARD off
 */
export const PAYMENT_FLAGS = {
  reservepay: import.meta.env.VITE_FEATURE_PAYMENT_RESERVEPAY !== 'false',
  bankTransfer: import.meta.env.VITE_FEATURE_PAYMENT_BANK_TRANSFER !== 'false',
  card: import.meta.env.VITE_FEATURE_PAYMENT_CARD === 'true',
  mobileBanking: import.meta.env.VITE_FEATURE_PAYMENT_MOBILE_BANKING === 'true',
  trueMoney: import.meta.env.VITE_FEATURE_PAYMENT_TRUE_MONEY === 'true',
  alipay: import.meta.env.VITE_FEATURE_PAYMENT_ALIPAY === 'true',
  wechat: import.meta.env.VITE_FEATURE_PAYMENT_WECHAT === 'true',
} as const

export type ReservePayMethod = 'promptpay' | 'card' | 'mobile_banking' | 'true_money' | 'alipay' | 'wechat'

/** Returns the default payment method when page loads.
 *  Priority: reservepay (promptpay) → card → bank transfer. */
export function getDefaultPaymentMethod(): 'reservepay' | 'bank_transfer' {
  if (PAYMENT_FLAGS.reservepay) return 'reservepay'
  return 'bank_transfer'
}

/** True when at least two payment options are visible (show the selector UI). */
export const SHOW_PAYMENT_SELECTOR =
  (PAYMENT_FLAGS.reservepay ? 1 : 0) + (PAYMENT_FLAGS.bankTransfer ? 1 : 0) + (PAYMENT_FLAGS.card ? 1 : 0) + (PAYMENT_FLAGS.mobileBanking ? 1 : 0) + (PAYMENT_FLAGS.trueMoney ? 1 : 0) + (PAYMENT_FLAGS.alipay ? 1 : 0) + (PAYMENT_FLAGS.wechat ? 1 : 0) >= 2

/** Mobile banking options from ReservePay */
export const MOBILE_BANKING_OPTIONS = [
  { name: 'BBL', displayName: 'Bualuang mBanking (BBL)', logo: '🏦' },
  { name: 'TTB_TOUCH', displayName: 'TTB Touch', logo: '🏦' },
] as const

export type MobileBankCode = (typeof MOBILE_BANKING_OPTIONS)[number]['name']
